import { useHistory } from "react-router";
//Styles and Icons
import styles from "./ApplicationGuid.module.scss";
import ArrowBackIcon from "../../../styles/icon/arrow_back_fill.svg";
import { useState } from "react";
export default function ApplicationGuid() {
  const { goBack } = useHistory();
  const [val, setVal] = useState("");
  const setLocal = () => {
    localStorage.setItem("token", val);
  };
  return (
    <div className={styles.container}>
      <header>
        <div className={styles.back_btn}>
          <img
            src={ArrowBackIcon}
            className="convertPicToWhite"
            alt="BACK"
            width={15}
            height={15}
            onClick={() => goBack()}
          />
        </div>
        <div className={`font_color_white ${styles.title}`}>راهنما</div>
      </header>
      <main>
        <div className="font_color_change_to_green">
          راهنمای خرید در ارزفی:{" "}
        </div>
        <div className="font_color_white">
          خرید و فروش ارز دیجیتال در صرافی ارزفی کاملا راحت و ساده میباشد.بعد از
          ثبت نام در صرافی و انجام مراحل احراز هویت شما میتوانید با ورود به بخش
          خرید یا فروش سفارش خودتان را ثبت نمایید.
          <br />
          نکته : برای خرید در سایت ارزفی ابتدا باید حساب کاربری خود را شارژ
          نموده سپس خرید خود را انجام دهید .
          <br />
          مرحله اول : ابتدا از قسمت حساب کاربری واریز ریالی برای مبالغ زیر 50
          میلیون تومان از طریق پرداخت آنلاین و برای مبالغ بالای 50 میلیون تومان
          از طریق واریز بانکی اعتبار حساب کاربری خود را شارژ می نمایید .
          <br />
          نکته : نحوه واریز بانکی به این صورت می باشد : ابتدا مبلغ مورد نظر خود
          را به یکی از شماره کارت های داده شده داخل سایت واریز کرده سپس شماره
          پیگیری و عکس از رسید خود را آپلود می نمایید که پس از بررسی از سمت واحد
          مالی (در صورتی که واریز از طریق سیستم پایا صورت گرفته باشد هر زمان
          مبلغ به حساب سایت واریز شود ) افزایش اعتبار صورت میگیرد و اعتبار
          کاربری شما شارژ می گردد .
          <br />
          <p className={styles.red_color}>
            اخطار:شما تنها مجاز به پرداخت با کارت های تایید شده در منوی پروفایل
            که به نام خودتان می باشد هستید
          </p>
          مرحله دوم : منوی خرید در قسمت منوی پایین سایت نمایش داده می شود . در
          قسمت خرید مقدار ارز مورد نظر خود یا مبلغ تومانی مورد نظر خود را وارد
          نموده و ارز خود را خریداری می نمایید . بلافاصله بعد از تایید خرید ،
          ارز به کیف پول ارزفی شما انتقال داده می شود .
          <br />
          نکته : شما میتوانید از قسمت کیف پول ها گزینه برداشت ارز خود را به آدرس
          کیف پول مورد نظر خود انتقال دهید برای انتقال ارز از کیف پول ارزفی به
          کیف پول خود درقسمت برداشت ابتدا آدرس کیف پول مقصد خود و بعد از آن
          مقدارمورد نظر را وارد نمایید سپس با انتخاب شبکه صحیح انتقال گزینه ثبت
          را بزنید در مرحله ی بعد کد دو عاملی تولید شده درگوگل اتنتیکیتور را در
          کادر وارد نمایید وثبت را بزنید و درآخردر هنگام انتقال ارز به شبکه ارز
          دقت فرمایید.
          <p className={styles.red_color}>
            اخطار : آدرس والت خود را در شبکه درست وارد نمایید مسئولیت آدرس کیف
            پول تماما بر عهده کاربر می باشد . برای ارزهای دارای تگ یا ممو حتما
            دقت نمایید تا تگ و ممو به درستی وارد شوند
          </p>
        </div>
        <div className="font_color_change_to_green">
          راهنمای فروش در ارزفی:{" "}
        </div>
        <div className="font_color_white">
          <p>
            حالت اول: در صورتیکه موجودی ارزی شما در کیف پول ارزفی باشد تنها از
            صفحه اصلی قسمت فروش یا گزینه خرید و فروش بالای صفحه کاربریتون مقدار
            مورد نظر ارز خود را وارد نموده درخواست فروش شما ثبت و بلافاصله
            اعتبار کاربری شما در ارزفی شارژ می گردد . در صورت تمایل می توانید از
            قسمت برداشت ریالی شماره کارت خود را انتخاب کرده تا مبلغ به حساب
            بانکی شما <span className={styles.red_color}>(طبق ساعات پایا)</span>{" "}
            واریز گردد .
          </p>
          <p>
            حالت دوم: در صورتیکه موجودی شما در کیف پولی خارج از ارزفی می باشد
            ابتدا از قسمت کیف پول ها واریز ، ارز مورد نظر را به کیف پول خود در
            ارزفی انتقال میدهید سپس از طریق صفحه اصلی قسمت فروش یا گزینه خرید و
            فروش بالای صفحه کاربریتون مقدار مورد نظر ارز خود را وارد نموده
            درخواست فروش شما ثبت و بلافاصله اعتبار کاربری شما در ارزفی شارژ می
            گردد . در صورت تمایل می توانید از قسمت برداشت ریالی شماره کارت خود
            را انتخاب کرده تا مبلغ به حساب بانکی شما{" "}
            <span className={styles.red_color}>(طبق ساعات پایا)</span> واریز
            گردد .
          </p>
        </div>
        <input onChange={(e) => setVal(e.target.value)} />
        <button onClick={() => setLocal()}>CONFIRM</button>
      </main>
    </div>
  );
}
